import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { unwrapAsset, unwrapRepeater } from "../../utils/CockpitUtils";
import ImageOrVideo from "../ImageOrVideo";
import "./usp-list.scss";

type USPListItemProps = {
  url?: string;
  heading: string;
  description: string;
  icon: string;
};

const USPList = ({
  items = [],
  heading = ""
}: {
  items: USPListItemProps[];
  heading: string;
}) => {
  items = unwrapRepeater(items);
  const isExternalUrl = /^https?:\/\//i;

  const LinkWrapper = ({
    link,
    children
  }: {
    link: USPListItemProps;
    children: ReactNode;
  }) =>
    link.url ? (
      isExternalUrl.test(link.url) ? (
        <a className="wrapper" href={link.url} target="_blank" rel="noreferrer">
          {children}
        </a>
      ) : (
        <Link className="wrapper" to={link.url}>
          {children}
        </Link>
      )
    ) : (
      <div className="wrapper">{children}</div>
    );

  return (
    <div className={`usp-list`}>
      {heading && <h2>{heading}</h2>}
      <ul>
        {items.map((link, j) => {
          const icon = unwrapAsset(link.icon);
          return (
            <li key={j}>
              <LinkWrapper link={link}>
                <>
                  {icon && (
                    <div className="icon-wrapper">
                      <ImageOrVideo
                        image={icon}
                        className={"icon"}
                        imageStyle={{ objectFit: "contain" }}
                      />
                    </div>
                  )}
                  <h3>{link.heading}</h3>
                  <p>{link.description}</p>
                </>
              </LinkWrapper>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default USPList;
